import { IconComponent } from '@graftcode/design-system'

import { ICON_MAP } from '../const/iconMap.const'
import { SEARCH_MODAL_ITEM_KIND } from '../const/modalItemKind.const'
import type { SearchModalItemKind } from '../types/modalItemKind.type'

import styles from '../SearchModal.module.scss'

type SearchRowIconProps = {
  kind?: SearchModalItemKind
}

export function SearchRowIcon({ kind }: SearchRowIconProps) {
  const icon = ICON_MAP[kind ?? SEARCH_MODAL_ITEM_KIND.Documentation]

  return (
    <span className={styles.rowIconWrap} data-row-icon={kind ?? SEARCH_MODAL_ITEM_KIND.Documentation}>
      <IconComponent icon={icon} className={styles.rowIconSvg} size={20} />
    </span>
  )
}
